// extracted by mini-css-extract-plugin
export default {"promoBar":"promo_bar__promoBar--46wH","promoBarContent":"promo_bar__promoBarContent--F+15","promoBarPanel":"promo_bar__promoBarPanel--Umrz"};